import { makeStyles } from '@material-ui/core';
import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  mainSectionRoot: {
    [theme.breakpoints.up('md')]: {
      overflow: 'auto',
      gridArea: 'main',
    },
  },
  productsSectionRoot: {
    paddingBottom: '5rem',
    overflow: 'auto',
    display: 'grid',
    gridTemplateRows: 'auto min-content',
    gridArea: 'products',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  root: {
    height: '100%',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      columnGap: '1rem',
      // gridTemplateAreas: `
      //                    "products main"
      //                    "products main"
      //                    "products management"
      //                    "footer management"`,
      // gridTemplateRows: 'auto 0fr 0fr 0fr',
      gridTemplateAreas: `
                         "products main"
                         "footer management"`,
      gridTemplateColumns: '1fr 21.5rem',
      gridTemplateRows: 'auto 0fr',
      '&[data-has-new-orders="false"]': {
        gridTemplateAreas: `
                         "products main"
                         "footer main"`,
      },
      overflow: 'hidden',
    },
  },
  orderManagementActionsRoot: {
    position: 'sticky',
    gridArea: 'management',
    display: 'flex',
    flexDirection: 'column',
    // height: '7.75rem',
  },
  blockContent: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'rgb(255 255 255 / 50%)',
  },
}));
